<template>
  <VDialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <VBtn
      slot="activator"
      color="primary"
      dark
    >
      {{ $t('createAgency') }}
    </VBtn>
    <VCard>
      <VCardTitle>
        <span class="headline">
          {{ $t('createAgency') }}
        </span>
      </VCardTitle>
      <VCardText>
        <VForm
          ref="form"
          v-model="isFormValid"
        >
          <VSubheader>{{ $t('agencyManager') }}</VSubheader>
          <VContainer
            grid-list-md
            class="pt-0"
          >
            <VLayout wrap>
              <VFlex xs6>
                <VTextField
                  v-model="agencyCreationObj.agency_manager.first_name"
                  :error-messages="errorMessages['agency_manager.first_name']"
                  :label="$t('firstName')"
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex xs6>
                <VTextField
                  v-model="agencyCreationObj.agency_manager.last_name"
                  :error-messages="errorMessages['agency_manager.last_name']"
                  :label="$t('lastName')"
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="agencyCreationObj.agency_manager.email"
                  :error-messages="errorMessages['agency_manager.email']"
                  :label="$t('email')"
                  :rules="[$rules.isRequired, $rules.isValidEmail]"
                />
              </VFlex>
            </VLayout>
          </VContainer>
          <VDivider />
          <VSubheader>{{ $t('agency') }}</VSubheader>
          <VContainer
            grid-list-md
            class="pt-0"
          >
            <VLayout wrap>
              <VFlex xs12>
                <VTextField
                  v-model="agencyCreationObj.agency.name"
                  :error-messages="errorMessages['agency.name']"
                  :label="$t('agencyName')"
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex>
                <VTextField
                  v-model="agencyCreationObj.agency.number"
                  :error-messages="errorMessages['agency.number']"
                  :label="$t('agencyNumber')"
                  :rules="[$rules.isRequired, $rules.isValidNumber]"
                />
              </VFlex>
              <VFlex>
                <VTextField
                  v-model="agencyCreationObj.agency.commission"
                  :error-messages="errorMessages['agency.commission']"
                  :label="$t('agencyCommission')"
                  :rules="[$rules.isRequired, $rules.isPercent]"
                />
              </VFlex>

              <VFlex xs12>
                <SelectCity
                  :value="{city: agencyCreationObj.agency.city, zip: agencyCreationObj.agency.zip}"
                  :rules="[$rules.isRequired]"
                  :error-messages="errorMessages['agency.city'] || errorMessages['agency.zip']"
                  @input="({zip, name}) => Object.assign(agencyCreationObj.agency, {zip, city: name})"
                />
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="agencyCreationObj.agency.street"
                  :error-messages="errorMessages['agency.street']"
                  :label="$t('agencyStreet')"
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
            </VLayout>
          </VContainer>
        </VForm>
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn
          flat
          @click="close"
        >
          {{ $t('close') }}
        </VBtn>
        <VBtn
          color="primary"
          :disabled="isValid"
          @click="createAgency"
        >
          {{ $t('add') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import AdminApi from '@/api/AdminApi'
import SelectCity from '@/components/global-components/inputs/SelectCity'

export default {
  name: 'AgencyCreate',
  components: { SelectCity },
  data () {
    return {
      isFormValid: false,
      dialog: false,
      agencyCreationObj: {
        agency: {
          number: '',
          name: '',
          commission: '',
          city: null,
          zip: null,
          street: ''
        },
        agency_manager: {
          first_name: '',
          last_name: '',
          email: ''
        }
      },
      errorMessages: {}
    }
  },
  computed: {
    isValid () {
      return !this.isFormValid && Object.getOwnPropertyNames(this.errorMessages).length === 1
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.errorMessages = {}
      this.$refs.form.reset()
    },
    async createAgency () {
      if (!this.isValid) {
        try {
          await this.$notification(AdminApi.createAgency(this.agencyCreationObj))
          this.$emit('onSuccess')
          this.close()
        } catch (e) {
          this.errorMessages = e
        }
      }
    }
  },
  i18n: {
    messages: {
      de: {
        createAgency: 'Neue Agentur',
        agencyManager: 'Managerdaten',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail',
        agencyStreet: 'Straße',
        agency: 'Agenturdaten',
        agencyName: 'Firmenname',
        agencyNumber: 'Agentur nummer',
        agencyCommission: 'Provision in Prozent',
        close: 'Abbrechen',
        add: 'Anlegen'
      },
      en: {
        createAgency: 'New agency',
        agencyManager: 'Data manager',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'E-Mail',
        agencyStreet: 'Street',
        agency: 'Agency data',
        agencyName: 'Company name',
        agencyNumber: 'Agency number',
        agencyCommission: 'Commission in percent',
        close: 'Cancel',
        add: 'Create'
      }
    }
  }
}
</script>
